import React from 'react';
import DocumentTitle from 'react-document-title';

import works from 'data/works';

import HeaderCompact from 'components/HeaderCompact';
import Page from 'components/Page';
import PageBody from 'components/PageBody';
import WorkGrid from 'components/Work';

export default () => (
  <Page>
    <DocumentTitle title="Work // Chris Tieman" />
    <HeaderCompact />
    <PageBody header="Work // All The Things" full>
      <WorkGrid data={works} />
    </PageBody>
  </Page>
);



// WEBPACK FOOTER //
// ./src/pages/Work.js